<template>
  <ContentPage back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">
        {{ me.account_name }}
      </div>
    </template>
    <div class="d-flex flex-column">
      <Contact :account="me" />
      <Address :account="me" />
      <Settings :account="me" />
      <Rewards :account="me" />
<!-- 
      LEAVING THIS HERE FOR WHEN WE COME BACK TO IT.
      
      <WithW9 v-if="w9" :w9="w9" />
      <NoW9 v-else />
-->
    </div>
  </ContentPage>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import { ContentPage } from '@/components/pages'
import Sections from './sections'

export default {
  components: {
    ContentPage,
    ...Sections,
  },
  
  computed: {
    ...mapGetters('accounts', ['me', 'w9']),
  },

  methods: {
    ...mapActions('accounts', ['loadMe', 'loadW9']),
  },

  async created() {
    this.loadMe()
    this.loadW9()
  },
}

</script>